import { render, staticRenderFns } from "./PackagesPlan.vue?vue&type=template&id=20c1b198"
import script from "./PackagesPlan.vue?vue&type=script&lang=js"
export * from "./PackagesPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports